import {Menu} from 'antd';
import React, {FC} from 'react';

import {useCustomLinkHandler} from 'features/provide-custom-link/hooks';
import {ICustomLinkSubmenuCommonProps} from 'features/provide-custom-link/model/types';
import {LinkView} from 'features/provide-custom-link/ui/view';
import {TLinkDto} from 'shared/types/links';

import s from './submenu-item.module.less';

interface ICustomLinkSubmenuItemProps extends ICustomLinkSubmenuCommonProps {
    link: TLinkDto;
}

export const SubmenuItem: FC<ICustomLinkSubmenuItemProps> = (props: ICustomLinkSubmenuItemProps) => {
    const {
        link,
        isLoading,
        setLoading,
        modalRef,
        extraStateData,
        actionCode,
    } = props ?? {};
    const {handleLinkClick, checkIsLoading} = useCustomLinkHandler({
        link,
        extraStateData,
        actionCode,
        setLoading,
    });

    return (
        <Menu.Item
            {...props}
            className={s['menu-item']}
            key={`${link.urlType}-${link.url}`}
            onClick={() => handleLinkClick(modalRef?.current?.showModalWithLink)}
        >
            <LinkView
                isSubmenuItem
                properties={link?.linkProperties}
                isLoading={checkIsLoading() || isLoading}
            />
        </Menu.Item>
    );
};
